import { IProperty } from '../utils/types';
import MonthAvailability from './MonthAvailability';

export type Props = {
  property: IProperty;
};

const YearAvailability = ({ property }: Props) => {
  const months = [];

  for (let i = 0; i < 14; i++) {
    months.push(<MonthAvailability key={i} property={property} offset={i} />);
  }

  return <>{months}</>;
};

export default YearAvailability;
